import ECOPortal from '@/views/integrations/ECOPortalExports.vue'

export const ecoPortalRoutes = {
  path: '/integrations/eco-portal',
  name: 'integrationEcoPortal',
  meta: { requiresAuth: true },
  component: ECOPortal,
  props: true,
}
